export const CategorizedListItemCategoryContainer = ({ children }) => (
  <div className="text-[#6C7275] mt-[16px] text-[14px] mr-3 font-medium flex gap-2">{children}</div>
)
